import script from "./DetailBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailBanner.vue?vue&type=script&setup=true&lang=js"

import "./DetailBanner.vue?vue&type=style&index=0&id=4b7cd32c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b7cd32c"]])

export default __exports__